(() => {
const data = document.getElementById('SweatshirtVariants');
const city = document.getElementById('CustomCity');
if (!data || !city) return;
const variants = JSON.parse(data.textContent);
const options = Array.from(document.querySelectorAll('[data-sweatshirt-option]'));
const form = city.closest('form');
const hidden = form.querySelector('input[name="id"]');
const button = form.querySelector('button[name="add"]');
const images = Array.from(document.querySelectorAll('.gallery-slide img'));
function sync() {
const selected = options.map(select => select.value);
const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
hidden.value = variant ? variant.id : '';
button.disabled = !variant || !variant.available;
button.textContent = button.disabled ? data.dataset.soldLabel : data.dataset.addLabel;
const color = selected[0].toLowerCase().replaceAll(' ', '-');
const image = images.find(img => img.src.includes('sudadera-' + color + '_') || img.src.includes('sudadera-' + color + '.'));
if (image) image.closest('[data-product-gallery]').dispatchEvent(new CustomEvent('gallery:select', { detail: images.indexOf(image) }));
}
options.forEach(select => select.addEventListener('change', sync));
city.addEventListener('input', () => city.setCustomValidity(''));
form.addEventListener('submit', event => {
sync();
if (!city.value.trim()) { event.preventDefault(); city.setCustomValidity('Escribe tu departamento o ciudad.'); city.reportValidity(); }
else city.value = city.value.trim();
if (!hidden.value || button.disabled) event.preventDefault();
});
sync();
})();